import BCH from "../assets/icons/BCH.png";
import BTC from "../assets/icons/BTC.png";
import ETH from "../assets/icons/ETH.png";
import LTC from "../assets/icons/LTC.png";
import XRP from "../assets/icons/XRP.png";
import company1 from "../assets/icons/company-1.png";
import company2 from "../assets/icons/company-2.png";
import company3 from "../assets/icons/company-3.png";
import company4 from "../assets/icons/company-4.png";
import frame1 from "../assets/icons/frame-1.png";
import frame2 from "../assets/icons/frame-2.png";
import frame3 from "../assets/icons/frame-3.png";
import frame4 from "../assets/icons/frame-4.png";
import fastExecution from "../assets/icons/fast-execution.png";
import tech from "../assets/icons/tech.png";
import dollar from "../assets/icons/dollar.png";
import competitivePricing from "../assets/icons/competitive-pricing.png";
import XM from "../assets/icons/XM.png";
import tradingPoint from "../assets/icons/trading-point.png";

export const loadIcon = {
  BCH,
  BTC,
  ETH,
  LTC,
  XRP,
  company1,
  company2,
  company3,
  company4,
  frame1,
  frame2,
  frame3,
  frame4,
  fastExecution,
  tech,
  dollar,
  competitivePricing,
  XM,
  tradingPoint,
};
